<template>
  <div class="rainbow">
    <div class="row">
      <div class="col-2 orange"></div>
      <div class="col-2 yellow"></div>
      <div class="col-2 pink-light"></div>
      <div class="col-2 pink"></div>
      <div class="col-2 green"></div>
      <div class="col-2 blue-light"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .rainbow {
    .row {
      max-height: 100px;
      overflow: hidden;
      margin: 0;
      > * {
        max-height: 100px;
        padding-bottom: 10%;
        &.orange {
          background-color: $color-orange;
        }
        &.yellow {
          background-color: $color-yellow;
        }
        &.pink-light {
          background-color: $color-pink-light;
        }
        &.pink {
          background-color: $color-pink;
        }
        &.green {
          background-color: $color-green;
        }
        &.blue-light {
          background-color: $color-blue-light;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Rainbow.vue